import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { PageContainer } from '@/components/layout/PageContainer'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '@/lib/store/authStore'
import { useStoreList } from '@/hooks/useStoreList'
import { StorefrontSettingsGuard } from './StorefrontSettingsGuard'
import { LineLoginSettings } from './LineLoginSettings'
import { LineMessagingSettings } from './LineMessagingSettings'

export function LineSettingsPage() {
  const navigate = useNavigate()
  const storefrontUrl = useAuthStore((s) => s.storefrontUrl)
  const activeStorefrontKey = useAuthStore((s) => s.activeStorefrontKey)
  const { data: stores = [] } = useStoreList()

  const scopedStorefrontUrl = useMemo(() => {
    if (!activeStorefrontKey) return storefrontUrl
    const store = stores.find((s) => s.storefront_key === activeStorefrontKey)
    return store?.domain ? `https://${store.domain}` : storefrontUrl
  }, [activeStorefrontKey, stores, storefrontUrl])

  return (
    <StorefrontSettingsGuard>
      <PageContainer>
        <div className="p-6 space-y-6">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              className="rounded-full"
              onClick={() => navigate('/storefront/settings')}
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div>
              <h2 className="text-2xl font-semibold">LINE Integration</h2>
              <p className="text-sm text-muted-foreground">
                Social login and messaging API
              </p>
            </div>
          </div>

          {/* key: remount per store so the one-shot form seeding re-runs with
              that store's LINE channel (QF-903 per-store credentials) */}
          <LineLoginSettings
            key={activeStorefrontKey ?? 'primary'}
            storefrontUrl={scopedStorefrontUrl ?? storefrontUrl ?? ''}
          />
          <LineMessagingSettings />
        </div>
      </PageContainer>
    </StorefrontSettingsGuard>
  )
}
